<template>
    <div class="page-user-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">好物兌換商品</div>
            <div class="breadcrumb-item">好物APP圖示設置-添加</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="100">
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>廣告名稱</span>
                                        </div>
                                        <Input v-model="form.name" style="width:100"/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
							    <Col span="25">
									<FormItem>
									    <div slot="label" class="form-label">
									    	<em class="red">* </em>
									        <span>圖片1</span>
									    </div>
									    <div class="form-upload-img">
									        <div class="img-preview" v-if="form.homepageimgOne">
									            <img :src="form.homepageimgOne" alt="">
									        </div>
									        <Upload :before-upload="handleBeforeUpload"
									                accept="image/png, image/jpg, image/jpeg"
									                action="">
									            <div class="upload-btn">選擇圖片</div>
									        </Upload>
									        <div class="upload-tip">尺寸：1125px*2436px，格式：PNG、JPG</div>
                                            <!-- <Input v-model="form.homepageimgOne" style="width:100"/> -->
									    </div>
									</FormItem>
							    </Col>
							</Row>
							
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>跳轉鏈結</span>
                                        </div>
                                        <Input v-model="form.url" style="width:100"/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>排序</span>
                                        </div>
                                        <Input v-model="form.sort" style="width:100"/>
                                    </FormItem>
                                </Col>
                            </Row>
							
                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">確定</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isSubmiting: false,
                imgone: '',
                imgtwo: '',
                pageParam: {},
                piclist: [],
                uploadFileOne: {
                    file: ''
                },
                uploadFileTwo: {
                    file: ''
                },
                form: {
                    id: '',
					status: '',
					url: '',
					image: '',
					name: '',
					sort: '',
					homepageimgOne: '',
                    homepageimgTwo: '',
                }
            };
        }, 
        mounted() {
            this.pageParam = this.$route.query;
			if(this.pageParam.id == undefined) {
				this.pageParam.id = 0;
			}
        },
        methods: {
            handleBack() {
                this.$router.go(-1);
            },
			handleBeforeUpload(file) {
                this.uploadFileOne.file = file;
                this.handleUploadImg();
                return false;
			},
			handleUploadImg() {
			    this.isSubmiting = true;
			    let formData = new FormData();
			    formData.append('file', this.uploadFileOne.file);

			    this.$Rq.requestAuth({
			        url: this.$Api.uploadImg,
			        method: 'post',
                    async: false,
			        data: formData,
			        headers: {
			            'Content-Type': 'multipart/form-data',
			        }
			    }).then((res) => {
			        this.isSubmiting = false;
			        if (res.code == 0) {
			            this.form.homepageimgOne = res.data.app_url + res.data.url;
                        this.piclist[0] = this.form.homepageimgOne;
			        } else {
			            this.$Utils.showTipInfo(res.msg);
			        }
			    }).catch((err) => {
			        this.isSubmiting = false;
			    });
			},
            handleBeforeUploadTwo(file) {
                this.uploadFileTwo.file = file;
                this.handleUploadImgTwo();
                return false;
            },
            handleUploadImgTwo() {
                this.isSubmiting = true;
                let formData = new FormData();
                formData.append('file', this.uploadFileTwo.file);

                this.$Rq.requestAuth({
                    url: this.$Api.uploadImg,
                    method: 'post',
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }).then((res) => {
                    this.isSubmiting = false;
                    if (res.code == 0) {
                        this.form.homepageimgTwo = res.data.app_url + res.data.url;
                        this.piclist[1] = this.form.homepageimgTwo;
                    } else {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },
            handleCheckForm() {
                let form = this.form;
                if (form.url == '') {
                    this.$Utils.showTipInfo('請輸入跳轉鏈結');
                    return;
                }
                if(form.name == ''){
                	this.$Utils.showTipInfo('請輸入廣告名稱');
                    return;
                }
				if (form.status == '') {
				    this.$Utils.showTipInfo('請選擇開啟狀態');
				    return;
				}
				if (form.sort == '') {
				    this.$Utils.showTipInfo('請輸入排序');
				    return;
				}
                if (form.homepageimgOne == '') {
                    this.$Utils.showTipInfo('請選擇圖片1');
                    return;
                }
                if (form.homepageimgTwo == '') {
                    this.$Utils.showTipInfo('請選擇圖片2');
                    return;
                }
                this.handleSubmit();
            },
            handleSubmit() {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.advertiserManageAdd,
                    method: 'post',
                    data: {
                        file: this.piclist,
                        name: form.name,
                        url: form.url,
                        status: form.status,
                        sort: form.sort,
                    },
                }).then((res) => {
                    this.isSubmiting = false;
                    if (res.code == 0) {
                        this.$Utils.showSuccess(res.msg);
                        this.form = {
		                    id: '',
							url: '',
							name: '',
							sort: '',
							status: '',
							homepageimgOne: '',
                            homepageimgTwo: '',
		                };
                        this.piclist = [];
                    } else {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "appbanneradvertiserManageAdd.scss";
</style>